import React, { useState, useRef, useEffect} from 'react';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import Icon from '@mdi/react';
import { observer } from 'mobx-react';
import './popup.scss';

interface IPopupComponent {
  trigger: boolean;
  setTrigger: any;
  title: string;
  icon?: any;
  children: any;
  handleCancel?: any;
  cancelText?: string;
  handleAction?: any;
  actionText?: string;
  handleOK?: any;
  okText?: string;
  loader?: boolean;
}

export const PopupComponent = (props: IPopupComponent) => {
  const {
    trigger,
    setTrigger,
    title,
    icon,
    children,
    handleCancel,
    cancelText,
    handleAction,
    actionText,
    handleOK,
    okText,
    loader,
  } = props;

  const[disableButton, setDisableButton] = useState(false);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const handleOKFunction = async () => {
    if(loader){
      setDisableButton(true);
      await handleOK();
      if (isMountedRef.current) {
        setDisableButton(false);
      }
    }
    else{
      await handleOK();
    }
  }
  return trigger ? (
    <Modal
      labelledBy="modal-title"
      className={`eft-action-modal modal-${title.replace(/ /g, '-').replace('?','')}`}
      isOpen={trigger}
      toggle={setTrigger}
      centered={true}
      aria-label={title}
    >
      <ModalHeader tag="h1" id="modal-title" toggle={cancelText? undefined : setTrigger} className="display-flex flex-align-center">
        {title ? title : null}
        {icon ? <Icon path={icon} title="" size={1} color="#005ea2" /> : null}
      </ModalHeader>

      <ModalBody>{children}</ModalBody>

      <ModalFooter className="text-right">
          {cancelText ? (
            <button className="usa-button usa-button--outline" onClick={handleCancel}>
              {cancelText}
            </button>
          ) : null}
          {actionText ? (
            <button className="usa-button" onClick={handleAction}>
              {actionText}
            </button>
          ) : null}
          {okText ? (
            <button className={`usa-button ${okText.length < 3 ? 'px-5' : ''}`} onClick={handleOKFunction} disabled={disableButton}>
              {okText}
            </button>
          ) : null}
      </ModalFooter>
    </Modal>
  ) : null;
};

export const Popup = observer(PopupComponent);
